/* eslint-disable */
/* eslint-disable no-console */
/* eslint-disable */
/* eslint-disable no-useless-escape */
/* eslint-disable sonarjs/no-duplicate-string */
import React, { useContext, useState } from 'react';
import {
  Grid,
  Typography,
  RACModalCard,
  RACButton,
  RACRadio,
  RACTextbox,
} from '@rentacenter/racstrap';
import { agreementGlobalStyles } from '../../JSstyles/agreementGlobalStyles';
import { getPrintDocument } from '../../api/user';
import { useTranslation } from 'react-i18next';
import { FeatureFlagContext } from '../../context/FeatureFlagContext';

interface SendDeliveryReceiptInterface {
  customerId: string;
  customerName: string;
  customerFirstName: string;
  customerLastName: string;
  email: string;
  phoneNumber: string;
  agreementId: string;
  sendDeliveryReceiptCompletedFn: any;
  sendDeliveryReceiptCancelledFn: any;
}
export default function SendDeliveryReceipt(
  props: SendDeliveryReceiptInterface
) {
  const { t } = useTranslation('split');
  const {
    customerId,
    customerName,
    customerFirstName,
    customerLastName,
    email,
    phoneNumber,
    agreementId,
    sendDeliveryReceiptCompletedFn,
    sendDeliveryReceiptCancelledFn,
  } = props;

    const { featureFlagDetails } = useContext(FeatureFlagContext);
  

  const classes = agreementGlobalStyles();
  const [sendDeliveryReceiptInput, setSendDeliveryReceiptInput] = useState({
    isEmailSelected: true,
    isTextSelected: false,
    emailTextValue: email,
    phoneTextValue: phoneNumber,
  });
  const [isValidEmailError, setIsValidEmailError] = useState(false);
  const [isValidPhoneNumError, setIsValidPhoneNumError] = useState(false);

  const SendDeliveryReceiptTxtOnChange = (field: any, value: any) => {
    if (field == 'Email') {
      setIsValidEmailError(false);
      setSendDeliveryReceiptInput({
        ...sendDeliveryReceiptInput,
        emailTextValue: value,
      });
    } else if (field == 'Text') {
      setIsValidPhoneNumError(false);
      setSendDeliveryReceiptInput({
        ...sendDeliveryReceiptInput,
        phoneTextValue: value,
      });
    }
  };

  const SendDeliveryReceiptRadioOnChange = (field: any) => {
    if (field == 'Email') {
      setIsValidEmailError(false);
      if (!sendDeliveryReceiptInput.isEmailSelected) {
        setSendDeliveryReceiptInput({
          ...sendDeliveryReceiptInput,
          isEmailSelected: true,
          isTextSelected: false,
        });
      } else {
        setSendDeliveryReceiptInput({
          ...sendDeliveryReceiptInput,
          isEmailSelected: false,
          isTextSelected: false,
        });
      }
    } else if (field == 'Text') {
      setIsValidPhoneNumError(false);
      if (!sendDeliveryReceiptInput.isTextSelected) {
        setSendDeliveryReceiptInput({
          ...sendDeliveryReceiptInput,
          isTextSelected: true,
          isEmailSelected: false,
        });
      } else {
        setSendDeliveryReceiptInput({
          ...sendDeliveryReceiptInput,
          isTextSelected: false,
          isEmailSelected: false,
        });
      }
    }
  };

  const sendDeliveryReceiptApiCall = () => {
    const storeDetails = sessionStorage.getItem('storeDetails') || '';
const encodeStoreDetails = Buffer.from(storeDetails, 'base64');
let decodestoreDetails: any;
    try {
        decodestoreDetails = JSON.parse(
            encodeStoreDetails.toString('utf8')
        );
    } catch (error: any) {
        console.log(error.message)
    }
  const countryAbb = decodestoreDetails?.country?.toUpperCase();
    const sendDeliveryReceiptPayload = {
      identifier: String(agreementId),
      identifierType: 'AGR',
      customerName: customerName,
      customerFirstName: customerFirstName || '',
      customerLastName: customerLastName || '',
      customerId: customerId,
      documentStatus: 'signed',
      originCountry : countryAbb,
      emailId: sendDeliveryReceiptInput.emailTextValue,
      actionType: sendDeliveryReceiptInput.isEmailSelected ? 'email' : 'text',
      digitalDeliveryType: 'RTOdigiSign',
      customerPhoneNumber: !sendDeliveryReceiptInput.isEmailSelected
        ? sendDeliveryReceiptInput.phoneTextValue.replace(/\D/g, '')
        : null,
      MXStore: featureFlagDetails.MXStoreIdentifier == "1" ? true : false
    };
    console.log('sendDeliveryReceiptPayload', sendDeliveryReceiptPayload);
    getPrintDocument(sendDeliveryReceiptPayload);
  };

  const sendClick = () => {
    if (sendDeliveryReceiptInput.isEmailSelected) {
      const emailRegex =
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if (emailRegex.test(sendDeliveryReceiptInput.emailTextValue)) {
        sendDeliveryReceiptApiCall();
        sendDeliveryReceiptCompletedFn();
      } else {
        setIsValidEmailError(true);
      }
    } else if (sendDeliveryReceiptInput.isTextSelected) {
      sendDeliveryReceiptApiCall();
      sendDeliveryReceiptCompletedFn();
    }
  };
  function sendBtnDisableValidation() {
    if (sendDeliveryReceiptInput.isEmailSelected) {
      if (sendDeliveryReceiptInput.emailTextValue.trim() == '') return true;
      else false;
    } else {
      if (sendDeliveryReceiptInput.phoneTextValue.trim().length < 10)
        return true;
      else false;
    }
  }
  const phoneNumberFormat = (value) => {
    return value
      .replace(/\D/g, '')
      .replace(
        /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
        '($1) $2-$3'
      );
  };
  const SendDeliveryReceiptPopup = () => {
    return (
      <Grid className={classes.p3}>
        <Grid container>
          <Grid item md={12} className={classes.mb3}>
            <Typography
              component="label"
              className={`${classes.formLabel} ${classes.w100} ${classes.fontBold}`}
            >
              {t('How do you want the delivery receipt to be shared?')}
            </Typography>
          </Grid>
          <Grid item md={12} className={classes.mb3}>
            <RACRadio
              value={sendDeliveryReceiptInput.isEmailSelected}
              checked={sendDeliveryReceiptInput.isEmailSelected}
              onChange={() => SendDeliveryReceiptRadioOnChange('Email')}
              label={t('Email')}
            />
            <RACRadio
              value={sendDeliveryReceiptInput.isTextSelected}
              checked={sendDeliveryReceiptInput.isTextSelected}
              onChange={() => SendDeliveryReceiptRadioOnChange('Text')}
              label={t('Text')}
              disabled={true}
            />
          </Grid>
          <Grid item md={6}>
            {sendDeliveryReceiptInput.isEmailSelected ? (
              <div>
                <RACTextbox
                  inputlabel={t('Email')}
                  inputLabelClassname="form-label"
                  name="Email"
                  value={sendDeliveryReceiptInput.emailTextValue}
                  OnChange={(e) =>
                    SendDeliveryReceiptTxtOnChange('Email', e.target.value)
                  }
                  isCurrency={false}
                  type="email"
                />
                {isValidEmailError ? (
                  <label
                    style={{
                      color: 'red',
                      fontSize: 'small',
                      marginLeft: '3%',
                    }}
                  >
                    {t('Please enter valid Email')}
                  </label>
                ) : null}
              </div>
            ) : (
              <div>
                <RACTextbox
                  inputlabel={t('Phone number')}
                  inputLabelClassname="form-label"
                  name="Phone number"
                  value={phoneNumberFormat(
                    sendDeliveryReceiptInput.phoneTextValue
                  )}
                  OnChange={(e) =>
                    SendDeliveryReceiptTxtOnChange('Text', e.target.value)
                  }
                  isCurrency={false}
                  type="text"
                  maxlength={10}
                />
                {isValidPhoneNumError ? (
                  <label
                    style={{
                      color: 'red',
                      fontSize: 'small',
                      marginLeft: '3%',
                    }}
                  >
                    {t('Please enter valid phone number')}
                  </label>
                ) : null}
              </div>
            )}
          </Grid>
        </Grid>

        <Grid
          item
          md={12}
          className={`${classes.pb4} ${classes.px3} ${classes.textRight}`}
        >
          <RACButton
            variant="outlined"
            color="primary"
            className={classes.mx1}
            name="SendAgreementCancel"
            onClick={() => {
              sendDeliveryReceiptCancelledFn();
            }}
          >
            {t('Cancel')}
          </RACButton>
          <RACButton
            variant="contained"
            color="primary"
            className={classes.mx1}
            name=""
            onClick={() => sendClick()}
            disabled={sendBtnDisableValidation()}
          >
            {t('Send')}
          </RACButton>
        </Grid>
      </Grid>
    );
  };
  return (
    <RACModalCard
      title={t('Send Delivery Receipt')}
      isOpen={true}
      borderRadius={'25px !important'}
      closeIcon={true}
      maxWidth="sm"
      onClose={() => {
        sendDeliveryReceiptCancelledFn();
      }}
    >
      {SendDeliveryReceiptPopup()}
    </RACModalCard>
  );
}
